import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const imageReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.CREATE_IMAGE:
    return { ...state, loading: true };
  case constants.CREATE_IMAGE_SUCCESS:
    return { ...state, loading: false, data: action.payload.data };
  case constants.CREATE_IMAGE_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_IMAGE:
    return initialState;
  default:
    return state;
  }
};

const initialImageByUrlState = {
  loading: false,
  data: null,
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const imageByUrlReducer = (state = initialImageByUrlState, action) => {
  switch (action.type) {
  case constants.CREATE_IMAGE_BY_URL:
    return { ...state, loading: true };
  case constants.CREATE_IMAGE_BY_URL_SUCCESS:
    return { ...state, loading: false, data: action.payload.data };
  case constants.CREATE_IMAGE_BY_URL_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_IMAGE_BY_URL:
    return initialImageByUrlState;
  default:
    return state;
  }
};
